import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "w-100 verify-card" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "pb-3" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "fv-row mb-10 ms-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "form-check form-check-custom form-check-solid mx-5" }
const _hoisted_10 = { style: {"margin-left":"50px","margin-top":"20px"} }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "row mt-5" }
const _hoisted_14 = {
  class: "d-flex align-items-center",
  style: {"border":"1px solid gray","border-radius":"10px","box-sizing":"border-box","padding":"20px"}
}
const _hoisted_15 = { class: "form-check form-check-custom form-check-solid mx-5" }
const _hoisted_16 = {
  class: "d-flex align-items-center mt-5",
  style: {"border":"1px solid gray","border-radius":"10px","box-sizing":"border-box","padding":"20px"}
}
const _hoisted_17 = { class: "form-check form-check-custom form-check-solid mx-5" }
const _hoisted_18 = { style: {"color":"#900000"} }

import { ref, watch } from "vue";
import { Field } from "vee-validate";
import questionDB from "@/core/data/wholesaleTest";
import { getBaDocs, baVerficationDocs } from "@/core/data/bcrDocs";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserAgreement',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;

const questions = ref<any>(questionDB["en-us"]);



const item = ref<any>({
  ...props.verificationDetails?.agreement,
});

watch(
  () => props.verificationDetails,
  () => {
    item.value = {
      ...props.verificationDetails?.agreement,
    };
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.agreement")), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.consent_1) = $event)),
                class: "form-check-input",
                type: "checkbox",
                value: ""
              }, null, 512), [
                [_vModelCheckbox, item.value.consent_1]
              ])
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("tip.verificationAgreementAcknowledgeTerms")), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baVerficationDocs), (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("a", {
                    href: _unref(getBaDocs)(item.title),
                    target: "_blank",
                    class: "cursor-pointer text-dark text-hover-primary"
                  }, _toDisplayString(_ctx.$t(`title.${index}`)), 9, _hoisted_12)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("title.electronicIdentityVerification")) + "*", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("tip.verificationAgreementElectronicIdentityVerification")), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.consent_2) = $event)),
                class: "form-check-input",
                type: "radio",
                name: "consent",
                value: "true"
              }, null, 512), [
                [_vModelRadio, item.value.consent_2]
              ])
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("tip.verificationAgreementConsentPassingInfo")), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.consent_2) = $event)),
                class: "form-check-input",
                type: "radio",
                name: "consent",
                value: "false"
              }, null, 512), [
                [_vModelRadio, item.value.consent_2]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("tip.verificationAgreementNotConsentPassingInfo")), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("tip.verificationAgreementPrepareId")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})